import { Star } from "lucide-react";
import { Button } from "../ui/button";

// "Make flock cover" for a duck in a real flock; on the chosen cover it goes back to the flock's newest duck.
export const CoverButton = ({ c, ctx, testId, compact = false }) => {
  const f = ctx.flock;
  if (!f) return null;
  const isCover = !!f.cover?.chosen && f.cover.id === c.id;
  const label = isCover ? "Flock cover" : "Make flock cover";
  return (
    <Button
      size="sm"
      variant={isCover ? "secondary" : "ghost"}
      data-testid={testId}
      aria-pressed={isCover}
      aria-label={label}
      title={isCover ? "This duck is the flock's cover. Tap to show the newest duck instead." : "Show this duck on the flock's header"}
      onClick={() => ctx.setCover(f.id, isCover ? null : c.id)}
      className={`h-8 rounded-full gap-1 text-xs ${compact ? "w-8 p-0" : ""}`}
    >
      <Star className={`h-3.5 w-3.5 transition-colors duration-200 ${isCover ? "fill-accent text-accent" : ""}`} />
      {!compact && label}
    </Button>
  );
};
